export default {
    SELECTED_FORMAT: 'selectedFormat',
    SELECTED_VIEW_TYPE: 'selectedViewType',
    START_DATE: 'dateRange.startDate',
    END_DATE: 'dateRange.endDate',
    MIN_DATE: 'dateParams.minDate',
    MAX_DATE: 'dateParams.maxDate'
};
